import React from "react";
import { Link } from "react-router-dom";
import { trackCTAClick } from '../utils/analytics';
import CelestialRecovery from "./celestialrecovery"; // Fixed import to match component name

const desktopThoughts = [
  { text: "I am not sure I am in the right career", className: "top-[8%] left-[2%]" },
  { text: "I feel like I am going in the wrong direction", className: "top-[10%] right-[2%]" },
  { text: "Why do I keep feeling this way?", className: "top-[34%] left-[1%]" },
  { text: "I cannot stop thinking about this", className: "top-[36%] right-[1%]" },
  { text: "I do not know what to do", className: "bottom-[30%] left-[2%]" },
  { text: "I feel stuck", className: "bottom-[28%] right-[2%]" },
  { text: "Something feels off", className: "bottom-[8%] left-[10%]" },
  { text: "I keep going in circles", className: "bottom-[8%] right-[10%]" },
];

const mobileThoughts = [
  "I feel like I am going in the wrong direction",
  "Why do I keep feeling this way?",
  "I do not know what to do",
  "I keep going in circles",
];

const Landinghero = () => {
  return (
    <div className="relative min-h-150 md:min-h-220 w-screen left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] flex items-center justify-center overflow-hidden font-serif text-indigo-100 ">
      {/* Celestial Background */}
      <CelestialRecovery />

      {/* Fused background image — web 31, above stars, below floating text */}
      <div className="absolute inset-0 z-1 pointer-events-none">
        <img
          src="/web_images/Andlegur%20web%2031.webp"
          alt=" Different Andlegur members finding their way to the sanctuary, depicted as a glowing doorway in a serene landscape, symbolizing the welcoming and transformative nature of the platform."
          className="w-full h-full object-cover opacity-20 mix-blend-screen"
          loading="eager"
          aria-hidden="true"
        />
        {/* Radial vignette — keeps centre readable, glow at edges */}
        <div
          className="absolute inset-0"
          style={{ background: 'radial-gradient(ellipse 55% 60% at 50% 50%, #05091Bbb 0%, #05091B11 65%, #05091B 100%)' }}
        />
      </div>

      {/* Thought bubbles around center content (desktop/tablet) */}
      <div className="pointer-events-none absolute inset-0 z-20 hidden md:block">
        {desktopThoughts.map((item, i) => {
          const bubbleTheme =
            i % 2 === 0
              ? "border-indigo-300/30 bg-[#0D1735]/78 text-indigo-100"
              : "border-violet-300/35 bg-[#2A1A4A]/70 text-violet-100";

          return (
            <div
              key={item.text}
              className={`absolute ${item.className} max-w-70 rounded-2xl border px-4 py-3 text-sm lg:text-base shadow-lg backdrop-blur-md ${bubbleTheme}`}
            >
              {item.text}
            </div>
          );
        })}
      </div>

      <div className="relative z-30 max-w-4xl w-full mx-auto text-center space-y-6 px-4 sm:px-8 md:px-10 py-8 md:py-16 bg-black/45 rounded-2xl backdrop-blur-md overflow-visible">
        <h1 className="text-3xl md:text-6xl font-bold tracking-wide leading-snug text-indigo-100">
          Your thoughts hold answers you haven’t noticed yet
        </h1>
        <p className="text-base md:text-xl text-indigo-100 pb-2 max-w-3xl mx-auto">
          Andlegur is your private space to reflect, gain insight, and find direction across your thoughts, emotions, and life decisions.
        </p>
        <Link
          to="/sanctuary"
          onClick={() => trackCTAClick('start_reflecting_hero', '/')}
          className="inline-flex bg-indigo-600 text-white px-7 py-3 rounded-full shadow-md hover:bg-indigo-500 hover:scale-105 transition"
        >
          Start Reflecting →
        </Link>

        {/* Reduced mobile thought bubbles */}
        <div className="md:hidden pt-2 grid grid-cols-1 gap-2 text-left max-w-xl mx-auto">
          {mobileThoughts.map((text) => (
            <div key={text} className="rounded-xl border border-indigo-300/20 bg-[#101B3D]/70 px-3.5 py-2.5 text-indigo-100 text-sm">
              {text}
            </div>
          ))}
          <Link
            to="/sanctuary"
            onClick={() => trackCTAClick('start_journey_mobile', '/')}
            className="mt-2 inline-flex justify-center rounded-xl bg-indigo-600 px-4 py-2.5 text-sm font-semibold text-white hover:bg-indigo-500 transition"
          >
            Andlegur helps you with those answers. Start your journey →
          </Link>
        </div>
      </div>

      <Link
        to="/sanctuary"
        onClick={() => trackCTAClick('start_journey_desktop_bottom', '/')}
        className="hidden md:inline-flex absolute bottom-8 left-1/2 -translate-x-1/2 z-30 rounded-full bg-indigo-600/95 px-7 py-3 text-white font-semibold shadow-lg hover:bg-indigo-500 transition"
      >
        Andlegur have those answers. Start your journey →
      </Link>
    </div>
  );
};

export default Landinghero;
